<template>
	<!-- <v-container> -->
		<v-row
			align 	= "center"
			justify = "center"
		>
			<v-col 
				xl 	  = "10" 
				lg 	  = "10" 
				md 	  = "10" 
				sm 	  = "12" 
				cols  = "12">
				<v-card outlined>
					<v-card-title 
						
						class  = "body-2 justify-center pa-1 secondary text-uppercase font-weight-bold white--text"
					>
						<v-icon 
							small 
							color  = "white"
							class  = "ml-1"
							@click = "$router.back()"
						>
							mdi-arrow-left-circle
						</v-icon>

						<v-spacer></v-spacer>
						
						<v-icon 
							small 
							color  = "primary"
							class  = "mx-1"
							
						>
							mdi-account-circle
						</v-icon>
						<span 
							v-text = "$ml.get('user')" 
						></span>
						
						<v-spacer></v-spacer>

					</v-card-title>
					<v-divider></v-divider>
					<v-card-text
						class = "pa-1"
					>
						<!-- <v-card> -->
      						<!-- fixed-tabs -->
						<v-tabs   
						    grow

      						dark 
      						height 	= "35"  
      						v-model = "tab"
      					>
      					<!-- centered -->
							<v-tab v-if = "canShowRegister">
								<v-icon 
									small 
									class = "mx-2"
								>
									mdi-account-plus
								</v-icon>
								{{ $ml.get('register') }}
							</v-tab>
							<v-tab v-if = "canShowList">
								<v-icon 
									small 
									class = "mx-2"
								>
									mdi-account-details
								</v-icon>								
								{{ $ml.get('list') }}

							</v-tab>
							<v-tab v-if = "canShowRoles">
								<v-icon 
									small 
									class = "mx-2"
								>
									mdi-account-multiple
								</v-icon>								
								{{ $ml.get('roles') }}

							</v-tab>
							<v-tab v-if = "canShowResources">
								<v-icon 
									small 
									class = "mx-2"
								>
									mdi-folder-account
								</v-icon>								
								{{ $ml.get('resources') }}

							</v-tab>
							<!-- <v-tab>
								<v-icon small> mdi-account-circle</v-icon> network
							</v-tab> -->
						</v-tabs>
						<!-- </v-card>	 -->
						<!-- <v-divider></v-divider>					 -->
						<v-tabs-items  
							v-model = "tab"
						>
								
							<v-tab-item v-if = "canShowRegister">
								<register/>
							</v-tab-item>
							<v-tab-item v-if = "canShowList">
								<user_list/>
							</v-tab-item>
							<v-tab-item v-if = "canShowRoles">
								<roles/>
							</v-tab-item>
							<v-tab-item v-if = "canShowResources">
								<resources/>
							</v-tab-item>
						</v-tabs-items>
					<!-- <v-divider></v-divider>					 -->
					</v-card-text>
					<!-- <v-card-actions>
					</v-card-actions> -->
				</v-card>
			</v-col>
		</v-row>
	<!-- </v-container> -->
</template>
<script>
import user_list 		from '@/components/user/user_list.vue'
import register 		from '@/components/user/register.vue'
import roles 			from "@/components/user/roles.vue"
import resources 		from "@/components/user/resources.vue"
	export default{
		name 		: 'user',
		components 	: { 
			user_list, 
			register, 
			roles,
			resources
		},
		data : ()=>({
			select 	: '',
			tab 	: null,
		}), // data
		created(){
			if (this.$store.state.auth.user){
	        // console.log(this.$store.state.auth.user.user.roleId, 'auth')
		        if (this.$store.state.auth.user.user.roleId == 3) {
		        	this.$router.push('dashboard')
		        }
	      	}
		}, // created 
		computed : {
			currentUser(){
				return this.$store.getters["auth/user"];
			},
			authPermissions(){
				return this.$store.state.auth.permissions;
			},
			isSuperAdmin(){
				return !!(this.currentUser && this.currentUser.user && this.currentUser.user.roleId == 1);
			},
			canShowRegister(){
				if (this.isSuperAdmin) {
					return true;
				}
				return this.hasUserPermission('can_add');
			},
			canShowList(){
				if (this.isSuperAdmin) {
					return true;
				}
				return this.hasUserPermission('can_view');
			},
			canShowRoles(){
				if (this.isSuperAdmin) {
					return true;
				}
				return this.hasAnyPermissionAction([
					'/api/v1/roles',
					'api/v1/roles',
					'/api/v1/role',
					'api/v1/role',
					'api_v1_roles',
					'api_v1_role',
					'roles'
				]);
			},
			canShowResources(){
				if (this.isSuperAdmin) {
					return true;
				}
				return this.hasAnyPermissionAction(['api_v1_resources', 'api_v1_resource', 'api_v1_permissions', 'api_v1_permission', 'api_v1_users']);
			}
		}, // computed
		watch: {
			canShowRegister(){
				this.syncTabSelection();
			},
			canShowList(){
				this.syncTabSelection();
			},
			canShowRoles(){
				this.syncTabSelection();
			},
			canShowResources(){
				this.syncTabSelection();
			}
		},
		methods: {
			hasUserPermission(action){
				const permissionGetter = this.$store.getters["auth/permission"];
				if (typeof permissionGetter === 'function' && permissionGetter('user', action, 'user')) {
					return true;
				}

				return !!(this.currentUser && this.currentUser.user && this.currentUser.user[action]);
			},
			hasAnyViewPermission(permissionNames){
				const permissionGetter = this.$store.getters["auth/permission"];
				const permissions = this.authPermissions;

				if (!permissions || typeof permissionGetter !== 'function') {
					return false;
				}

				return (permissionNames || []).some((permissionName) => {
					return permissionGetter(permissionName, 'can_view', permissionName);
				});
			},
			hasAnyPermissionAction(permissionNames){
				const permissionGetter = this.$store.getters["auth/permission"];
				const permissions = this.authPermissions;
				const actions = ['can_view', 'can_add', 'can_edit', 'can_delete'];

				if (!permissions || typeof permissionGetter !== 'function') {
					return false;
				}

				return (permissionNames || []).some((permissionName) => {
					return actions.some((action) => permissionGetter(permissionName, action, permissionName));
				});
			},
			syncTabSelection(){
				const visibleCount = [
					this.canShowRegister,
					this.canShowList,
					this.canShowRoles,
					this.canShowResources,
				].filter(Boolean).length;

				if (!visibleCount) {
					this.tab = null;
					return;
				}

				const currentTab = Number(this.tab);
				if (Number.isNaN(currentTab) || currentTab < 0 || currentTab >= visibleCount) {
					this.tab = 0;
				}
			}
		},
		mounted(){
			this.syncTabSelection();
		}

	};
</script>
